module.exports = __webpack_public_path__ + "static/media/rupee_symbol.8de8a64c.svg";